import useCampaigns from '../useCampaigns';
import useNonNullContext from 'Hooks/useNonNullContext';
import { OptionsContext } from 'contexts/OptionsContext/OptionsContext';
import { CampaignTableRow } from '../CampaignsTable/ReportCampaignsTable';

export function useReportYoutubeCampaigns() {
    const { currencies } = useNonNullContext(OptionsContext);
    const {
        campaignsData,
        projectsData,
        brandsData,
        teamsData,
        campaignStatsData,
        isTeamsLoading,
        isProjectsLoading,
        getIsBrandLoading,
        getIsCampaignStatsLoading,
    } = useCampaigns('youtube');

    const rows: CampaignTableRow[] =
        campaignsData.data?.results?.map((campaign) => {
            const project = projectsData.get(campaign.project_id) ?? null;
            const brand = (project && brandsData[project.brand_id]?.data) || null;
            const team = project ? teamsData?.get(project.team_id) ?? null : null;
            const currency = currencies.find((c) => c.id === campaign.currency_id);

            return {
                ...campaign,
                stats: campaignStatsData[campaign.id]?.data ?? null,
                project,
                brand,
                team,
                currency,
            };
        }) ?? [];

    return {
        rows,
        isLoading: campaignsData.isLoading,
        isTeamsLoading,
        isProjectsLoading,
        getIsBrandLoading,
        getIsCampaignStatsLoading,
    };
}
